import type {Editor} from 'grapesjs';

export interface EmailMakerMoreOptionsSheetProps {
  editor: Editor;
}

export interface MoreOptionsMenuConfig {
  canShareInTeam: boolean;
  isSharedInTeam: boolean;
  isShareToggleLoading: boolean;
  isVersionHistoryAccessible: boolean;
  onShareInTeamToggle: () => void;
}

export enum MoreOptionsView {
  MAIN = 'main',
  EXPORT = 'export',
}

export enum MoreOptionsItem {
  POST_TO_SOCIAL = 'post-to-social',
  PUBLISH_AS_WEBPAGE = 'publish-as-webpage',
  PREVIEW = 'preview',
  EXPORT = 'export',
  EXPORT_COPY = 'export-copy',
  EXPORT_COPY_AS_TEXT = 'export-copy-as-text',
  EXPORT_DOWNLOAD = 'export-download',
  SHARE_IN_TEAM = 'share-in-team',
  NEW_EMAIL = 'new-email',
  DUPLICATE = 'duplicate',
  VERSION_HISTORY = 'version-history',
  SETTINGS = 'settings',
  HELP_CENTER = 'help-center',
}

export function isMoreOptionsItem(id: string): id is MoreOptionsItem {
  return Object.values(MoreOptionsItem).includes(id as MoreOptionsItem);
}
